export default __webpack_public_path__ + "static/media/0039.f89af295.png";